import React from 'react';
import { Card, Row, Col, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';


const TitleField = ({ listingData, handleChange, errors }) => {
    const { t } = useTranslation();


    return (
        <Card variant="borderless" style={{ marginBottom: 24 }}>
            <Row gutter={16}>
                <Col span={12} md={16}>
                    <Form.Item
                        required
                        label={t("propertyDetails.rentalTitle")}
                        help={errors?.title?.[0]}
                        validateStatus={errors?.title ? "error" : ""}
                    >
                        <Input
                            name="title"
                            value={listingData.title || ""}
                            onChange={handleChange}
                            placeholder={t("propertyDetails.rentalTitle")}
                            size="large"
                        />
                    </Form.Item>
                </Col>
                <Col span={12} md={16}>
                    <Form.Item
                        required
                        label={t("propertyDetails.rentalTitleGr")}
                        help={errors?.title_gr?.[0]}
                        validateStatus={errors?.title_gr ? "error" : ""}
                    >
                        <Input
                            name="title_gr"
                            value={listingData.title_gr || ""}
                            onChange={handleChange}
                            placeholder={t("propertyDetails.rentalTitleGr")}
                            size="large"
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
}

export default TitleField;